import { render, staticRenderFns } from "./OrganizationPendingPlan.vue?vue&type=template&id=36e28df3&"
import script from "./OrganizationPendingPlan.vue?vue&type=script&lang=js&"
export * from "./OrganizationPendingPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports